import { render, staticRenderFns } from "./RequestReview.vue?vue&type=template&id=5190a5eb&scoped=true"
import script from "./RequestReview.vue?vue&type=script&lang=js"
export * from "./RequestReview.vue?vue&type=script&lang=js"
import style0 from "./RequestReview.vue?vue&type=style&index=0&id=5190a5eb&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5190a5eb",
  null
  
)

export default component.exports